import React from 'react'
import styled from 'styled-components'
import tw from 'twin.macro'
import { InfoIcon } from '@components/Icons'

function ErrorMessage(props) {
  const { error, index, errorMessages, setErrorMessages } = props
  const removeErrorMessage = (index) => {
    errorMessages.splice(index, 1)
    setErrorMessages([...errorMessages])
  }

  return (
    <StyledErrorMessage>
      <StyledInfoIcon />
      <span className="message">{error}</span>
      <span className="ok-btn" onClick={() => removeErrorMessage(index)}>
        OK
      </span>
    </StyledErrorMessage>
  )
}

const StyledErrorMessage = styled.div`
  ${tw`flex items-center justify-between`}
  padding: 12px 16px;
  background-color: rgba(226, 56, 56, 0.05);
  border: 1px solid rgba(226, 56, 56, 0.2);
  border-radius: 0px 16px 16px 16px;
  margin-top: 8px;
  .message {
    ${tw`text-gray-800`}
    font-size: 12px;
    width: 560px;
  }
  .ok-btn {
    ${tw`bg-secondary-close`}
    ${tw`text-white`}
    ${tw`text-center`}
    ${tw`cursor-pointer`}
    width: 42px;
    height: 24px;
    line-height: 24px;
    border-radius: 24px;
    font-size: 12px;
  }
`
const StyledInfoIcon = styled(InfoIcon)`
  path {
    fill: #e23838;
  }
`
export default ErrorMessage
